import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "50px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", textAlign: "left"}}>
      <h1>EdXcelerate Privacy Policy</h1>
      <p><strong>Effective Date:</strong> January 1, 2025</p>
      <p><strong>Contact:</strong> Ryan Foulke – ryan@edxcelerate.com</p>
      
      <p>
        At EdXcelerate, protecting the privacy of our users—particularly students—is fundamental to our mission. 
        We are committed to ensuring that all personal information is handled in accordance with applicable laws, 
        including the <strong>Family Educational Rights and Privacy Act (FERPA)</strong>, and in a transparent, secure, and respectful manner.
      </p>
      <p>
        This Privacy Policy explains how we collect, use, and protect your information when you use the EdXcelerate 
        platform and services (collectively, the "Service").
      </p>

      <h2>1. What This Policy Covers</h2>
      <p>
        This Privacy Policy covers how EdXcelerate collects, uses, and shares personal information about users of our platform. 
        It also describes your rights and choices with respect to your personal data.
      </p>
      <p>This Policy applies to all users, including students, educators, and institutional partners.</p>

      <h2>2. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Information you provide directly:</strong> such as your name, email address, academic interests, school affiliation, and any other content you enter into the Service.</li>
        <li><strong>Educational records:</strong> Information voluntarily submitted that may be considered part of your education record, subject to FERPA protections.</li>
        <li><strong>Usage data:</strong> Information about how you use the platform, including pages visited, time spent, and preferences.</li>
        <li><strong>Third-party integrations:</strong> If you link your account to a third-party tool (e.g., Google Drive or an LMS), we may collect basic profile or file data as permitted by that tool's settings.</li>
        <li><strong>Cookies and device information:</strong> We use cookies and similar technologies to enhance your experience, track usage, and improve our services.</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide and improve the Service;</li>
        <li>Communicate with you about your account, educational planning tools, and updates;</li>
        <li>Ensure legal compliance, especially with <strong>FERPA</strong> and other applicable student privacy laws;</li>
        <li>Respond to support requests and enhance user experience;</li>
        <li>Detect and prevent misuse or violations of our policies.</li>
      </ul>
      <p>We do not sell personal information. Student data will never be used for advertising or non-educational profiling.</p>

      <h2>4. Sharing Your Information</h2>
      <p>We may share your information under the following circumstances:</p>
      <ul>
        <li>With service providers who support platform functionality (e.g., cloud storage, analytics), under strict confidentiality and security obligations;</li>
        <li>With educational institutions, only when required to support educational planning or authorized by the student or parent/guardian;</li>
        <li>With law enforcement or regulators, if legally required or in good faith belief that such disclosure is necessary to comply with legal obligations or protect users;</li>
        <li>With your consent, for any specific purposes you approve.</li>
      </ul>
      <p>We may share de-identified or aggregated data that cannot reasonably identify you.</p>

      <h2>5. Data Security and Retention</h2>
      <p>
        We use commercially reasonable administrative, technical, and physical safeguards to protect your information. 
        However, no system is completely secure. Users are responsible for keeping their login credentials safe.
      </p>
      <p>
        We retain your information only as long as necessary to provide the Service or comply with legal and educational obligations.
      </p>

      <h2>6. Your Choices and Rights</h2>
      <p>You may:</p>
      <ul>
        <li>Request access to or correction of your personal data;</li>
        <li>Request deletion of your account;</li>
        <li>Control cookies through your browser settings;</li>
        <li>Contact us regarding any concerns about how your data is handled.</li>
      </ul>
      <p>To exercise these rights, contact ryan@edxcelerate.com.</p>

      <h2>7. FERPA and Student Privacy</h2>
      <p>
        EdXcelerate is designed with student privacy at its core. All handling of education records complies with the 
        <strong>Family Educational Rights and Privacy Act (FERPA)</strong>. We will not disclose any FERPA-protected information without 
        proper authorization or consent.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Any material changes will be communicated to you directly or 
        through a notice on our platform.
      </p>

      <h2>9. Contact</h2>
      <p>
        If you have questions or concerns about this Privacy Policy, or wish to make a data request, please contact:
      </p>
      <p>
        Ryan Foulke<br />
        Email: ryan@edxcelerate.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;